import * as types from '../constants/ActionTypes';

const initialState = {
    couponResults: {},
    depositCouponResults: []
};

export default function (state = initialState, action = {}) {
    switch (action.type) {
        case types.MY_COUPON.MY_COUPON_RESULTS:
            return Object.assign({}, state, {couponResults: action.data});
        case types.MY_COUPON.MY_COUPON_LISTS:
            return Object.assign({}, state, {depositCouponResults: action.data});

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./common/reducers/CouponLists.js